import { useDispatch, useSelector } from 'react-redux';
import { history } from "sites/state/store";
import { isSiteInitedSelector, screenWidthSelector, showNSFWModalSelector, siteInfoSelector } from 'sites/state/modules/common/selectors';
import { setShowNSFWModalAction } from 'sites/state/modules/common/actions';
import ModalWrapper from 'common/components/modules/modal-wrapper';
import Router from 'sites/routes/router';
import intercomMoreInfo, { CONTACT_SUPPORT } from 'sites/utils/IntercomMoreInfo';
import classNames from 'classnames';
import { getIsFacialDetectionAgeVerificationMethod } from 'sites/utils/utils';

import './style.scss'

const NSFWContentWarningModal = () => {
   const showNSFWModal = useSelector(showNSFWModalSelector)
   const screenWidht = useSelector(screenWidthSelector)
   const siteInfo = useSelector(siteInfoSelector)
   const isSiteInited = useSelector(isSiteInitedSelector);

   const dispatch = useDispatch()
   const setShowNSFWModal = (bool) => dispatch(setShowNSFWModalAction(bool))

   if(Router.route('AGE_VERIFICATION').match(window.location.pathname)) {
      setShowNSFWModal(false)
   }

   if(!showNSFWModal || !isSiteInited || Router.route('AGE_VERIFICATION').match(window.location.pathname)) {
      return null
   }

   const isMobile = screenWidht <= 1024

   const getModalDescription = () => {
      if(getIsFacialDetectionAgeVerificationMethod(siteInfo.age_verification_location?.code_segment)) {
         // eslint-disable-next-line no-useless-escape
         return `<h3 dir=\"ltr\" style=\"line-height: 1.38; margin-top: 14pt; margin-bottom: 4pt;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><b>Adult Content Warning - Age Verification Required in ${ siteInfo?.age_verification_location?.segment || 'your location' }</b></span></h3><p dir=\"ltr\" style=\"margin-top: 12pt; margin-bottom: 12pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">This website contains content intended for adults only. Access is restricted to individuals who are&nbsp;</span><b><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">18 years of age or older</span><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">.</span></b></p><p dir=\"ltr\" style=\"margin-top: 12pt; margin-bottom: 12pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">By entering this site, you certify that:</span></p><ul style=\"margin-bottom: 0px; padding-inline-start: 48px;\"><li dir=\"ltr\" aria-level=\"1\" style=\"list-style-type: disc; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><p dir=\"ltr\" role=\"presentation\" style=\"margin-top: 12pt; margin-bottom: 0pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">You are at least 18 years old.</span></p></li><li dir=\"ltr\" aria-level=\"1\" style=\"list-style-type: disc; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><p dir=\"ltr\" role=\"presentation\" style=\"margin-top: 0pt; margin-bottom: 0pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">You understand that this website contains adult-oriented material.</span></p></li><li dir=\"ltr\" aria-level=\"1\" style=\"list-style-type: disc; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><p dir=\"ltr\" role=\"presentation\" style=\"margin-top: 0pt; margin-bottom: 12pt; line-height: 1.38;\"><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">You agree to our terms and conditions and privacy policy.</span></p></li></ul><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\">To comply with ${ siteInfo?.age_verification_location?.segment || 'your location' } law, we use an age verification system to ensure minors cannot access harmful content.&nbsp;</span><span style=\"font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline;\"><b>Your personal information will NOT BE STORED AFTER VERIFICATION.</b></span><br>`
      }

      if(siteInfo.age_verification_description) {
         return siteInfo.age_verification_description
      }

      return 'This site contains adult content (NSFW). You must verify your age to see the content.'
   }

   return (
      <ModalWrapper
         contentWidth='800px'
         isMobile={ isMobile }
         isPreventDeafault={ false }
         type='confirm'
         icon='warning'
         iconColor='warning'
         iconSize='2xl'
         title='Adult Content Warning'
         // description={ siteInfo.age_verification_description || 'This site contains adult content (NSFW). You must verify your age to see the content.' }
         // descriptionColorClass='text-secondary dark:text-secondary-dark age_verification_html_description text-start'
         buttonText='Ok, close'
         nonPrimaryColor
         buttonClassName='mt-8 shrink-0'
         primaryButtonClassName='!px-[6px]'
         textColor='secondary dark:text-secondary-dark'
         action={ () => {
            setShowNSFWModal(false)
         } }
         secondButtonTitle='Verify my age'
         secondButtonWrapperClassName='shrink-0'
         overrideSecondButtonProps={ {
            primaryColor: true,
         } }
         secondButtonClassName='!px-[6px]'
         secondButtonAction={ () => {
            setShowNSFWModal(false)
            history.push(Router.route('AGE_VERIFICATION').getCompiledPath())
         } }
         cancelText='Contact support'
         cancelButtonWrapperClassName='shrink-0'
         secondaryButtonClassName='!px-[6px] intercom-adult-content-warning'
         cancelButtonAction={ () => {
            intercomMoreInfo(CONTACT_SUPPORT, { type: 'adult-content-warning' })
         } }
         modalWrapperClassName='flex flex-col'
         className='max-h-full flex-1 overflow-y-hidden'
         withoutCloseButton={ false }
         closeBtnClassName='shrink-0'
         onCloseModal={ () => setShowNSFWModal(false) }
      >
         <div
            className={ classNames({
               'w-full max-h-full flex justify-center flex-1 overflow-y-auto mt-4': true,
               'ams-custom-scrool': !isMobile,
            }) }
         >
            <span
               className='text-major dark:text-major-dark age_verification_html_description text-start'
               dangerouslySetInnerHTML={ { __html: getModalDescription() } }
            />

         </div>
      </ModalWrapper>
   )
}

export default NSFWContentWarningModal;
